<template src='./remittanceIntegrationCreationModal.pug' lang='pug'></template>

<script>
import vSelect from 'vue-select'
import ConfirmModal from '../../modals/confirmModal/ConfirmModal'
import BetterModal from '../../modals/betterModal/BetterModal'
import DateRange from '../../input/dateRange/DateRange'
import ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'

export default {
  name: 'RemittanceIntegrationCreationModal',

  components: {
    vSelect,
    ConfirmModal,
    BetterModal,
    DateRange,
    ButtonPrimary
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    remittanceTypes: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      firstDate: new Date(),
      finalDate: new Date(),
      hasRemittance: false,
      isLoadingData: false,
      remittance: {
        type: '',
        period: {},
        comments: ''
      },
      modal: {
        text: {
          title: this.$t('remessaIntegracao.remessa.gerar.modal.titulo'),
          subtitle: this.$t('remessaIntegracao.remessa.gerar.modal.subtitulo')
        }
      }
    }
  },

  methods: {
    clearRemittance () {
      this.remittance = {
        type: '',
        period: {},
        comments: ''
      }
    },

    validate () {
      return new Promise(resolve => {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.$store.dispatch('validateRemittancePeriod', this.remittance)
              .then(hasRemittance => {
                this.hasRemittance = hasRemittance
                $('#confirmRemittanceCreation').modal('show')
              })
            resolve()
          }
        })
      })
    },

    create () {
      this.closeModalConfirm()
      this.isLoadingData = true
      return new Promise((resolve, reject) => {
        this.$store.dispatch('createRemittance', this.remittance)
          .then(response => {
            this.clearRemittance()
            this.isLoadingData = false
            this.$root.$refs.notification.success('remessaIntegracao.mensagem.sucesso')
            this.$emit('close-modal')
            resolve()
          })
          .catch(error => {
            this.$root.$refs.notification.error(error)
            this.isLoadingData = false
            reject()
          })
      })
    },

    closeModalConfirm () {
      $('#confirmRemittanceCreation').modal('hide')
    }
  }
}
</script>

<style lang='css' scopped>
#main-container.main-container {
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 15px;
}

#statuses-container {
  margin-top: 10px;
}

.modal-lg {
  width: 75vw;
}

.modal .modal-content {
  border-left: none;
  border-bottom: none;
  border-right: none;
}

.form-style {
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding-bottom: 15px;
}

.control-label {
  margin-top: 15;
}
</style>



// WEBPACK FOOTER //
// RemittanceIntegrationCreationModal.vue?1286edc2